import { Button } from 'antd'
import React from 'react'
import { useDispatch } from 'react-redux'
import Actions from '../../../actions'
import $t from '../../../i18n'
import Card from '../Card'
import SwitchLanguage from '../SwitchLanguage'
import Page from '../Page/Page'

import './PageCard.css'

export const PageCard = ({
  children,
  headerComponent,
  className,
  enableBack,
  enableSkip,
  onSkip,
  onBack,
  switchLanguage = false,
  ...others
}) => {
  const dispatch = useDispatch()
  return (
    <Page className={'page-with-card ' + className} {...others}>
      <Card className="page-card">
        {headerComponent}
        {switchLanguage && (
          <div className="switch-language">
            <SwitchLanguage />
          </div>
        )}
        <div className="page-card-content">
          <div className="page-card-header">
            {enableBack && (
              <div className="streach">
                <i
                  className="icon-arrow-bold-left back-btn"
                  onClick={
                    onBack
                      ? onBack
                      : () =>
                          dispatch(Actions.createAction(Actions.NAVIGATED_BACK))
                  }
                  data-hidden={!enableBack}
                />
              </div>
            )}
            <Button
              type="link"
              className="skip-btn"
              onClick={onSkip}
              data-hidden={!enableSkip}
            >
              {$t('common.skip')}
            </Button>
          </div>
          {children}
        </div>
      </Card>
    </Page>
  )
}

export default PageCard
